import React from 'react';
import PropTypes from 'prop-types';
import { withPageSection } from '@components/PageSection';
import Icon from '@components/Icon';
import Button from '@components/Button';
import styles from './LinksSection.module.css';

const LinksSection = ({ items }) => {
  return (
    <div className={styles.root}>
      <ul className={styles.list}>
        {items?.map((item, index) => (
          <li key={index} className={styles.item}>
            <Button
              variant="link"
              colorScheme="text"
              href={item.href}
              className={styles.linkItem}
              withArrow
            >
              <Icon icon={item.icon} className={styles.icon} />
              <span className={styles.label}>{item.label}</span>
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
};

LinksSection.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      icon: PropTypes.string,
    }),
  ),
};

export default withPageSection(LinksSection);
